<script setup>
import { formatTime } from '@/utils/datetime'

const props = defineProps({
  feature: {
    type: Object,
    required: true
  },
  settings: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['highlight'])

const highlightFeature = () => {
  emit('highlight', props.feature)
}
</script>

<template>
  <div
    class="p-0.5 rounded hover:bg-muted/50 cursor-pointer"
    @click="highlightFeature"
  >
    <div class="flex items-center">
      <div
        class="w-3.5 h-3.5 rounded-full mr-1"
        :style="`background-color: ${props.feature.properties.color || props.feature.properties.template_color || '#0059ff'}`">
      </div>
      <span class="text-sm">{{ props.feature.properties.name }}</span>
    </div>
    <div class="text-xs text-muted-foreground flex justify-between flex-wrap gap-2">
      <span>{{ props.feature.geometry.type }}</span>
      <span>{{ formatTime(props.feature.properties.created_at, props.settings.tz, 'D MMM YYYY HH:mm') }}</span>
    </div>
    <div v-if="props.feature.properties.data" class="mt-2 text-xs">
      <div v-if="typeof props.feature.properties.data === 'object'" class="flex flex-wrap gap-1">
        <span
          v-for="(value, key) in props.feature.properties.data"
          :key="key"
          class="px-1.5 py-0.5 bg-muted rounded"
        >
          <span>{{ value.key }}: {{ value.value }}</span>
        </span>
      </div>
      <div v-else class="px-1.5 py-0.5 bg-muted rounded">
        {{ props.feature.properties.data }}
      </div>
    </div>
  </div>
</template>
